import { useSuspenseQuery } from "@tanstack/react-query";
import { createRoute, type AnyRoute } from "@tanstack/react-router";

import { loadView, viewQuery } from "@/api/views";
import { brandHead } from "@/lib/head";
import QuoteEditPage from "@/pages/app/quotes/[id]/edit/page";

import { appRoute, APP_BOUNDARIES } from "./w0b";

const QuoteEditRouteComponent = () => {
  const { id } = quoteEditRoute.useParams();
  const { data } = useSuspenseQuery(viewQuery("quote-edit", { id }));
  return <QuoteEditPage data={data} />;
};

export const quoteEditRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/quotes/$id/edit",
  loader: ({ context, params }) => loadView(context.queryClient, viewQuery("quote-edit", { id: params.id })),
  head: () => brandHead("견적 편집"),
  component: QuoteEditRouteComponent,
  ...APP_BOUNDARIES,
});

// g1c 배치의 라우트 — 견적 편집기.
export const routes: AnyRoute[] = [quoteEditRoute];
